export const DEFAULT_ACTIVE_TAG = 'all';
export const RECENTLY_ITEM_WIDTH = 300;
export const SIMILAR_ITEM_WIDTH = 400;
export const PROMO_TIMER_TYPES = {
  BEGIN: 'begin',
  END: 'end',
  FINISHED: 'finished',
  AVAILABLE_AGAIN: 'availableagain'
};

export const PROMOTION_ITEM_TYPES = {
  PROMOTION: 'promotion',
  TOURNAMENT: 'tournament',
  BONUS: 'bonus'
};

export const PROMO_TYPES = {
  promotion: 'promotions',
  tournament: 'tournaments',
  bonus: 'bonuses',
  widget: 'widget'
};

export const BONUS_SYSTEM_TYPE = {
  CRM: 'CRM',
  BS: 'BS'
};

export const ALL_TYPES_BONUSES_COUNT = 'allTypesBonusesCount';
export const BONUSES_SECTION_AVAILABLE = 'available';
export const BONUSES_SECTION_ACTIVE = 'active';

export const SCHEDULING_TYPE = {
  DAY: 'day',
  WEEK: 'week'
};

// TODO: use only one type on constant everywhere - PROMOTION_ITEM_TYPES
// then this might be removed
export const PROMOTION_ITEM_TYPE_TO_PROMO_TYPE = {
  [PROMOTION_ITEM_TYPES.PROMOTION]: PROMO_TYPES.promotion,
  [PROMOTION_ITEM_TYPES.TOURNAMENT]: PROMO_TYPES.tournament,
  [PROMOTION_ITEM_TYPES.BONUS]: PROMO_TYPES.bonus
};

export const BONUSES_EXPIRED_TYPES = [
  'BONUS_RELEASED',
  'BONUS_INCOME_NOT_ACHIEVED',
  'BONUS_OUTPUT_NOT_ACHIEVED',
  'BONUS_WASNOT_ACTIVATED',
  'BONUS_CANCELED',
  'FREE_SPIN_USED',
  'FREESPIN_EXPIRED',
  'FREESPIN_INCOME_NOT_ACHIEVED',
  'FREESPIN_RELEASED',
  'FREESPIN_CANCELED',
  'completed',
  'expired_potential',
  'expired_proposed',
  'expired_wagering_period',
  'cancelled_by_player',
  'cancelled_by_manager'
];

export const PROMO_TAGS = {
  CASINO: 'casino',
  SPORT: 'sport',
  NEW: 'new'
};

export const DEFAULT_PROMO_TYPE = PROMO_TYPES.promotion;

export const DEFAULT_PROMO_TAGS = [
  {
    tagBackground: 'var(--accent_color_3)',
    tagId: PROMO_TAGS.CASINO
  },
  {
    tagBackground: 'var(--accent_color_1)',
    tagId: PROMO_TAGS.SPORT
  },
  {
    tagId: 'youAreIn',
    tagBackground: 'transparent',
    tagColor: 'state_success',
    tagFontSize: 's',
    tagIcon: 'icons/general/state/success'
  }
];

export const TOURNAMENT_LEADERBOARD_TOP_PLAYERS_LIMIT = 10;

export const PROMO_FREQUENCY_STATES = {
  NO_RESTRICTIONS: 'noRestrictions',
  ONCE_PER_N_DAYS: 'oncePerNDays'
};

export const PROMO_LIMITATION_STATES = {
  NO_RESTRICTIONS: 'noRestrictions',
  LIMITED: 'limited'
};

export const BONUS_SOURCE_TYPE = {
  BS_PWB: 'bs_pwb',
  BS_PWS: 'bs_pws',
  BS_FS: 'bs_fs',
  CRM_FUNDS: 'crm_funds',
  CRM_FREE_SPINS: 'crm_free_spins',
  CRM_RISK_FREE: 'crm_risk_free'
};
